module.exports = __webpack_public_path__ + "img/favicon.2682305c.png";